import * as React from "react";
import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        // text-base dan bukan text-sm dengan sengaja: Safari iOS mengezum masuk
        // secara automatik apabila medan input mempunyai saiz fon di bawah 16px,
        // dan zum itu tidak berpatah balik selepas medan hilang fokus.
        "flex h-11 w-full rounded-md border border-input bg-background px-3 py-2 text-base",
        "ring-offset-background placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
